import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [player, setPlayer] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("wsbf_token");
    if (!token) {
      setUser(null);
      setPlayer(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setPlayer(data.player);
    } catch {
      localStorage.removeItem("wsbf_token");
      setUser(null);
      setPlayer(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const loginWithToken = async (token) => {
    localStorage.setItem("wsbf_token", token);
    await refresh();
  };

  const logout = () => {
    localStorage.removeItem("wsbf_token");
    setUser(null);
    setPlayer(null);
  };

  const hasRole = (...roles) =>
    !!user && roles.some((r) => (user.roles || []).includes(r));

  const isAdmin = !!user && user.role === "admin";

  return (
    <AuthCtx.Provider
      value={{ user, player, loading, refresh, loginWithToken, logout, hasRole, isAdmin }}
    >
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
